import { Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography, Pagination, Box, Select, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BusCancellationReports = () => {
  const [cancellations, setCancellations] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Start from 1
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);  

  const fetchCancellations = async (page) => {
    try {
      const response = await axios.get(
        `https://api.ipaisa.co.in/myapp/bus/cancellations/report?page=${page}`, // Use page directly
        {
          headers: {
            Authorization: '••••••',
          },
        }
      );
      setCancellations(response.data.cancellations);
      setTotalRecords(response.data.pagination.totalElements);
    } catch (error) {
      console.error('Error fetching cancellation data:', error);
    }
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value); // No need to subtract 1
    fetchCancellations(value); // Fetch data for the new page
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setCurrentPage(1); // Reset to the first page when page size changes
    fetchCancellations(1); // Fetch data for the first page
  };

  // Fetch data on component mount and when currentPage or pageSize changes
  useEffect(() => {
    fetchCancellations(currentPage);
  }, [currentPage, pageSize]);

  return (
    <Box sx={{ padding: "2rem", marginTop: "3%" }}>
        <Grid item xs={12} md={12}>
            <TableContainer
                sx={{
                borderRadius: "12px",
                overflow: "hidden",
                background: "white",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                }}
            >
                <Table>
                <TableHead>
                    <TableRow
                    sx={{
                        background: "linear-gradient(45deg, #0152a9, #4a90e2)",
                    }}
                    >
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "1.1rem" }}>
                        Change Request ID
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "1.1rem" }}>
                        Bus ID
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "1.1rem" }}>
                        Cancellation Charge
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "1.1rem" }}>
                        Credit Note No
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "1.1rem" }}>
                        Cancelled At
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "1.1rem" }}>
                        Refunded Amount
                    </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {cancellations.length > 0 ? (
                    cancellations.map((cancellation) => (
                        <TableRow key={cancellation.changeRequestId}>
                        <TableCell>{cancellation.changeRequestId}</TableCell>
                        <TableCell>{cancellation.busId}</TableCell>
                        <TableCell>₹{cancellation.cancellationCharge}</TableCell>
                        <TableCell>{cancellation.creditNoteNo}</TableCell>
                        <TableCell>{cancellation.cancelledAt}</TableCell>
                        <TableCell>₹{cancellation.refundedAmount}</TableCell>
                        </TableRow>
                    ))
                    ) : (
                    <TableRow>
                        <TableCell colSpan={6} align="center">
                        <Typography variant="body1" sx={{ fontStyle: "italic" }}>
                            No cancellations available
                        </Typography>
                        </TableCell>
                    </TableRow>
                    )}
                </TableBody>
                </Table>
            </TableContainer>

          {/* Pagination */}
          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            style={{ marginTop: "1%" }}
          >
            <Grid item>
              <Select
                variant="outlined"
                value={pageSize}
                onChange={handlePageSizeChange}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
              <Typography display="inline" style={{ marginLeft: 8 }}>
                Showing {(currentPage - 1) * pageSize + 1} to{" "}
                {Math.min(currentPage * pageSize, totalRecords)} out of{" "}
                {totalRecords} records
              </Typography>
            </Grid>
            <Grid item>
              <Pagination
                count={Math.ceil(totalRecords / pageSize)}
                color="primary"
                page={currentPage} // Use currentPage directly
                onChange={handlePageChange}
              />
            </Grid>
          </Grid>
        </Grid>
    </Box>
  );
};

export default BusCancellationReports;
